module.exports = __webpack_public_path__ + "img/gas-meter-sm.2466118b.svg";